// libraries
import type { StateTree } from '@makemydeal/dr-dash-types';

export const getMetaData = (state: StateTree): any => {
    return state.metaData || {};
};
